
import ColorTemperatureSwatch from '@/components/ColorTemperatureSwatch.vue'
import { colorTemperatureGradient, kelvinToCss } from '@/utils/colorTemperature'

const ICON_SCALE = { min: 2500, max: 8500 }

export default {
  name: 'ProductTechnicalFilterChipLabel',
  components: { ColorTemperatureSwatch },
  props: {
    chip: {
      type: Object,
      required: true,
    },
    chevron: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    gradientStyle() {
      const scale =
        this.chip.active && this.chip.value
          ? { min: this.chip.value[0], max: this.chip.value[1] }
          : ICON_SCALE
      const warm = kelvinToCss(scale.min)
      const cool = kelvinToCss(scale.max)

      return {
        background: colorTemperatureGradient(scale),
        boxShadow: `-2px 0 6px ${warm}, 2px 0 6px ${cool}, inset 0 0 0 1px rgba(15, 23, 42, 0.12)`,
      }
    },
  },
}
